import { render, staticRenderFns } from "./CampusWrapper.vue?vue&type=template&id=c30075ce"
import script from "./CampusWrapper.vue?vue&type=script&lang=js"
export * from "./CampusWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports